import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, contentClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';

export const getAllDailyBooks: ApiMethod<
  { startingFrom: string | undefined; typeName: string | undefined },
  Server.DailyContentOutput[],
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_DailyContent_Client(
      undefined,
      contentClient
    );
    const response = await client.dailyContent_get_V1(
      undefined,
      data.startingFrom,
      data.typeName
    );
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const addNewDailyContentToTheEnd: ApiMethod<
  Server.AddDailyContentToQueueInput,
  number,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_DailyContent_Client(
      undefined,
      contentClient
    );
    const response = await client.dailyContent_add_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};

export const addNewDailyContentToSpicificDate: ApiMethod<
  Server.AddDailyContentToSpecificDateInput,
  number,
  any
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_DailyContent_Client(
      undefined,
      contentClient
    );
    const response = await client.dailyContent_addDate_post_V1(data);
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    // Show alert
    const errors = { ...error.response }.data;
    dispatch(
      CommonActions.setAlert({
        type: AlertType.WARNING,
        messages: JSON.parse(errors).errors || [
          { message: 'Something went wrong' },
        ],
      })
    );
    return rejectWithValue(error);
    throw error;
  }
};
